import firebaseApp from "@/firebase/init.js"
import { getMessaging } from "firebase/messaging/sw";

const messaging = getMessaging(firebaseApp);
export default messaging
